import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessExplainerById } from '@api/data-security';

export const getCoreDataSecurityAccessExplainerByIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessExplainerById',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessExplainerById,
	retainDataOnRequest: true
});
